import { z } from 'zod';
/**
 * La contraseña, con una sola definición para todo el sistema: login, recuperación por email,
 * cambio con la sesión abierta y la temporal que genera el servidor al dar de alta a alguien.
 *
 * Estaba repetida en `login.ts` y `password-reset.ts`, que es exactamente la clase de regla que
 * después se endurece en un lugar y queda floja en otro.
 */
export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 200;
export const PasswordSchema = z.string().min(PASSWORD_MIN).max(PASSWORD_MAX);
